import React, { useEffect, useState } from "react";
import Logo from "../../images/logo.png";
import { QRCodeCanvas } from "qrcode.react";
// import jwt from "jsonwebtoken";

function formatNumber(number, length) {
  return String(number).padStart(length, "0");
}

function convertNumberToWords(number) {
  const units = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
  ];
  const tens = [
    "",
    "Ten",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];
  const teens = [
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];
  const crore = "Crore";
  const lakh = "Lakh";
  const arab = "Arab";
  const currency = "Rupees";
  const paisa = "Paisa";

  if (number === 0) {
    return "Zero " + currency;
  }

  let words = "";

  if (number >= 1000000000) {
    words +=
      convertNumberToWords(Math.floor(number / 1000000000)) + " " + arab + " ";
    number %= 1000000000;
  }
  if (number >= 10000000) {
    words +=
      convertNumberToWords(Math.floor(number / 10000000)) + " " + crore + " ";
    number %= 10000000;
  }

  if (number >= 100000) {
    words +=
      convertNumberToWords(Math.floor(number / 100000)) + " " + lakh + " ";
    number %= 100000;
  }

  if (number >= 1000) {
    words += convertNumberToWords(Math.floor(number / 1000)) + " Thousand ";
    number %= 1000;
  }

  if (number >= 100) {
    words += convertNumberToWords(Math.floor(number / 100)) + " Hundred ";
    number %= 100;
  }

  if (number >= 20) {
    words += tens[Math.floor(number / 10)] + " ";
    number %= 10;
  } else if (number >= 10) {
    //console.log(number);
    words += teens[number - 10] + " ";
    number = 0;
    //console.log(words);
  }

  if (number > 0) {
    words += units[number] + " ";
  }
  const decimalPart = Math.round((number % 1) * 100);
  //console.log(decimalPart);
  if (decimalPart > 0) {
    words += "and" + decimalPart + " " + paisa + "only ";
  }

  //console.log(words);
  return words.trim() + " ";
}

const InvoicePage = ({getData, incentive}) => {
  const userID = sessionStorage.getItem("TRCUserId");
  const userEmail = sessionStorage.getItem("TRCUserEmail");
  const userName = sessionStorage.getItem("TRCUserName");
  const userPosition = sessionStorage.getItem("TRCUserPosition");

  // const payload = {
  //   iss: "custom",
  //   data: {
  //     SellerGstin: "33AAKCT9681P1ZC",
  //     BuyerGstin: getData?.dealerData?.gst,
  //     DocNo: `TRC/${getData?.invoiceId}/${getFiscalYearLabel(new Date(getData?.date))}`,
  //     DocDt: formatViewDate(getData?.date),
  //     TotInvVal: payable,
  //     ItemCnt: getData?.orderData?.length,
  //     MainHsnCode: "04011000",
  //     Irn: getData?.eInvNo
  //   }
  // };

  // const token = jwt.sign(payload, "your-secret-key", {
  //   algorithm: "HS256"
  // });

  // const getData = orderDatas;

  // console.log(incentive);
  // console.log(getData);

  const [total, setTotal] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [gst, setGST] = useState(0);
  const [gst2, setGST2] = useState(0);
  const [qty, setQty] = useState(0);
  const [discount, setDiscount] = useState(getData?.discount || 0);
  const [scheme, setScheme] = useState(getData?.schemeValue || 0);
  const [crates, setCrates] = useState(0);
  const [weight, setWeight] = useState(0);
  const [discounts, setDiscounts] = useState(
    JSON.parse(getData?.discountData || "[]")
  );

  // console.log(getData);

  const companyData = {
    companyName: "TRUCOO DAIRY PRODUCTS PRIVATE LIMITED",
    companyAddress1: "C201, SK Hill view Apartment",
    companyAddress2: "Rainbow Enclave",
    companyLocation: "Sugunapuram Myilkal",
    companyCity: "Coimbatore",
    companyState: "Tamil Nadu",
    companyZip: "641008",
    companyPhone: "+91 81900 03400",
    companyEmail: "cbeoffice@trucoo.in",
    companyGst: "33AAKCT9681P1ZC",
    ts: "Sample Terms and Conditions",
    code: "33",
  };

  // function customRound(num) {
  //     const decimalPart = num % 1;
  //     if (decimalPart < 0.5) {
  //       return Math.floor(num) + 0.5;
  //     } else {
  //       return Math.ceil(num);
  //     }
  // };

  const getTotal = () => {
    let allTotal = 0;
    let allGst = 0;
    let allQty = 0;
    let allSubTotal = 0;
    let discount = 0;
    let crate = 0;
    let weight = 0;

    getData?.orderData?.forEach((data) => {
      const price = parseFloat(data.itemPrice) || 0;
      const gst = parseFloat(data.itemGst) || 0;
      const disCrates = getDiscountCrates(data.itemId);

      const productGst = price - price / (1 + gst / 100) || 0;
      const productPrice = parseFloat(price - productGst).toFixed(2) || 0;

      allTotal +=
        price *
        (parseFloat(data.qty) + parseFloat(disCrates)) *
        parseFloat(data.itemGrade);
      allGst += parseFloat(
        (
          productPrice *
          (parseFloat(data.qty) + parseFloat(disCrates)) *
          parseFloat(data.itemGrade) *
          (parseFloat(data.itemGst / 2) / 100)
        ).toFixed(2)
      );
      allSubTotal +=
        productPrice *
        (parseFloat(data.qty) + parseFloat(disCrates)) *
        parseFloat(data.itemGrade);
      allQty +=
        (parseFloat(data.qty) + parseFloat(disCrates)) *
          parseFloat(data.itemGrade) || 0;
      crate += parseFloat(data.qty) + parseFloat(disCrates);
      weight +=
        (parseFloat(data.qty) + parseFloat(disCrates)) *
        parseFloat(data.itemGrade) *
        (parseFloat(data.itemWeight) / 1000);
    });

    discount += parseFloat(getData?.discount) || 0;
    // Set the final values
    setTotal(allSubTotal);
    setGST(allGst);
    setGST2(parseFloat(allGst / 2).toFixed(2));
    setQty(allQty);
    setGrandTotal(allTotal);
    setDiscount(discount);
    setScheme(parseFloat(getData?.schemeValue || 0));
    setCrates(crate);
    setWeight(weight);
  };

  const getDiscountCrates = (product) => {
    const productData = getData?.orderData?.find(
      (items) => items.itemId === product
    );
    const discountData = discounts?.find((items) => items.item === product);

    if (!productData || !discountData) {
      //console.warn("Product or discount not found");
      return 0;
    }

    const qty = parseFloat(productData.qty);
    const price = parseFloat(productData.itemPrice);
    const crates = parseFloat(productData.itemGrade);
    const weight = parseFloat(productData.itemWeight);
    const gst = parseFloat(productData.itemGst);
    const productGst = price - price / (1 + gst / 100) || 0;
    const productPrice = price - productGst || 0;

    if (isNaN(qty) || isNaN(productPrice) || isNaN(crates) || isNaN(weight)) {
      console.warn("Invalid product data");
      return 0;
    }

    if (!discountData.value || isNaN(discountData.value)) {
      console.warn("Invalid discount value");
      return 0;
    }

    if (discountData.discount === "amount") {
      return 0;
    }

    if (discountData.type === "grade") {
      if (discountData.crate === "packet") {
        return (parseFloat(discountData.value) * qty) / crates;
      } else {
        return (parseFloat(discountData.value) * qty) / productPrice / crates;
      }
    }

    if (discountData.type === "percent") {
      const total = qty * crates * productPrice;
      return total * (parseFloat(discountData.value) / 100);
    }

    if (discountData.type === "liters") {
      if (discountData.crate === "litre") {
        const ltrs = qty * crates * (weight / 1000);
        const discLtr = ltrs * discountData.value;
        return discLtr / crates;
      } else {
        const ltrs = qty * crates * (weight / 1000);
        const ltrprice = ltrs * discountData.value;
        const ltrQty = ltrprice / productPrice;
        return ltrQty / crates;
      }
    }

    return 0;
  };

  const formatViewDate = (date) => {
    const newDate = new Date(date);
    if (isNaN(newDate)) {
      //console.error("Invalid date format");
      return;
    }

    const formattedDate = `${String(newDate.getDate()).padStart(
      2,
      "0"
    )}-${String(newDate.getMonth() + 1).padStart(
      2,
      "0"
    )}-${newDate.getFullYear()}`;
    return formattedDate;
  };

  const payable = (
    parseFloat(parseFloat(total) + parseFloat(gst) + parseFloat(gst)) -
    parseFloat(discount) -
    parseFloat(scheme)
  ).toFixed(2);
  const totalAmountInWords = convertNumberToWords(
    parseFloat(Math.round(payable)).toFixed(0)
  );

  const ewayQr = `EWB no. : ${getData?.eWayNum} / ${
    companyData?.companyGst
  } / Date : ${formatViewDate(getData?.dealerData?.date)}`;

  useEffect(() => {
    getTotal();
    setDiscounts(JSON.parse(getData?.discountData || "[]"));
  }, [getData]);

  useEffect(() => {
    getTotal();
  }, [discounts]);

  const note = `TRC/${getData?.invoiceId}/${getFiscalYearLabel(
    new Date(getData?.dealerData?.date)
  )}`;
  const upiId = "73601701@ubin";
  const payeeName = "TRUCOO DAIRY PRODUCTS PRIVATE LIMITED";
  const payableQR = parseFloat(Math.round(payable).toFixed(2));

  const generateUpiLink = () => {
    const upiLink = `upi://pay?pa=${upiId}&am=${payableQR}&cu=INR&pn=${payeeName}&tn=${note}`;
    return upiLink;
  };

  function getFiscalYearLabel(date = new Date()) {
    const year = date.getFullYear();
    const month = date.getMonth();
    if (month < 3) {
      return `${(year - 1).toString().slice(-2)}-${year.toString().slice(-2)}`;
    } else {
      return `${year.toString().slice(-2)}-${(year + 1).toString().slice(-2)}`;
    }
  }

  //console.log(getData?.discount)
  const i = 15 - getData?.orderData?.length;

  // console.log(incentive);

  const formatDateEinv = (dateStr) => {
    if(!dateStr){
      return
    }

    const [year, month, day] = dateStr.split("-");
    const date = new Date(`${year}-${month}-${day}`);

    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "2-digit"
    });
  };
  
  return (
    <>
      {/* --------------Sheet 1 ------------ */}

      <section
        className="invoice hide"
        id="printableArea1"
        style={{
          maxWidth: "265mm",
          minWidth: "265mm",
          padding: "20px",
          boxSizing: "border-box",
          border: "1px solid #fff",
          justifyContent: "center",
        }}
      >
        <div style={{ marginTop: "-10px", marginBottom: "10px" }}>
          <small style={{fontSize: '9px'}}>( ORIGINAL FOR RECIPIENT )</small>
        </div>
        <div className="row align-items-top justify-content-center">
          <div className="col-sm-3">
            <img src={Logo} width="100%" />
          </div>

          <div className="col-sm-6 text-center fs-13">
            <h4 style={{ fontWeight: "600" }}>
              {companyData?.companyName}
            </h4>
            <address>
              {companyData?.companyAddress1}, {companyData?.companyAddress2}
              <br />
              {companyData?.companyLocation}, {companyData?.companyCity},
              {companyData?.companyState} - {companyData?.companyZip} <br />
              GSTIN : {companyData?.companyGst} &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
              State : {companyData?.companyState} &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
              Code : {companyData?.code} <br />
              Phone : {companyData?.companyPhone} &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp; 
              Email : {companyData?.companyEmail}
            </address>
          </div>

          <div className="col-sm-3 d-flex justify-content-end gap-2">
            {payable && payable > 0 && (
              <div style={{display: 'flex', flexDirection: 'column', textAlign: 'center'}}>
                <QRCodeCanvas value={generateUpiLink()} size={110} />
                <small>Payment</small>
              </div>
            )}
            {getData?.eInvData?.length > 10 && (
              <div style={{display: 'flex', flexDirection: 'column', textAlign: 'center'}}>
                <QRCodeCanvas value={getData?.eInvData} size={110} />
                <small>E-Invoice</small>
              </div>
            )}
          </div>

          <div className="table-responsive">
            <table className="table table-bordered text-dark fs-12" width="100%">
              <thead>
                <tr>
                  <th className="text-center" colSpan="3">
                    Tax Invoice
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td width="70%">
                    <address>
                      <p className="text-uppercase">
                        Billing Address
                      </p>
                      <h6 style={{ fontWeight: "600", fontSize: "14px" }}>
                        {getData?.dealerData?.dealer}
                      </h6>
                      {getData?.dealerData?.address} - {}{getData?.dealerData?.pincode}
                      <br />
                      GSTIN : {getData?.dealerData?.gst} &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                      State : {getData?.dealerData?.state} &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                      Code : {getData?.dealerData?.stateCode}
                      <br />
                      {getData?.dealerData?.phone} &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                      {getData?.dealerData?.email}
                    </address>
                  </td>
                  <td width="30%" className="fs-13" >
                    <p className="text-uppercase">Invoice Details</p>
                    <div className="flex justify-between">
                      <p>Date</p>
                      <p>{formatViewDate(getData?.date)}</p> 
                    </div>
                    <div className="flex justify-between">
                      <p>Invoice No</p>
                      <p>TRC/{getData?.invoiceId}/{getFiscalYearLabel(new Date(getData?.date))}</p>
                    </div>
                    <div className="flex justify-between">
                      <p>Route</p>
                      <p>{getData?.dealerData?.routes}</p>
                    </div>
                    {/* <div className="flex justify-between">
                      <p>Place</p>
                      <p>{getData?.dealerData?.locations}</p>
                    </div> */}
                    <div className="flex justify-between">
                      <p>Vehicle No</p>
                      <p>{getData?.vNum}</p>
                    </div>
                    <div className="flex justify-between">
                      <p>E-Way Bill</p>
                      <p>{getData?.eWayNum}</p>
                    </div>
                  </td>
                </tr>
              </tbody>
              </table>
              
              {getData?.eInvNo?.length > 5 &&
                <table className="table table-bordered text-dark fs-12" width="100%">
                  <thead>
                    <tr>
                      <th>IRN : {getData?.eInvNo}</th>
                      <th>Ack No : {getData?.eInvAkn}</th>
                      <th>Ack Date : {formatDateEinv(getData?.date)}</th>
                    </tr>  
                  </thead>    
                </table>
              }

              <table className="table table-bordered text-dark fs-12" width="100%">
              <tbody>
                <tr>
                  <td
                    width="50%"
                    className="text-dark"
                    style={{ verticalAlign: "top" }}
                  >
                    <address>
                      <p className="text-dark text-uppercase">
                        Shipping Address
                      </p>
                      <h6 style={{ fontWeight: "600", fontSize: "14px" }}>
                        {getData?.shipping?.company}
                      </h6>
                      {getData?.shipping?.address}
                      <br />
                      State : {getData?.dealerData?.state}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp; 
                      Code : {getData?.dealerData?.stateCode}
                      <br />
                      {getData?.shipping?.phone} &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                      {getData?.shipping?.email}
                    </address>
                  </td>
                  <td className="text-dark" style={{ verticalAlign: "top" }}>
                    <address>
                      <p className="text-dark text-uppercase">Dispatch From</p>
                      <h6 style={{ fontWeight: "600", fontSize: "14px" }}>
                        {getData?.dispatch?.company}
                      </h6>
                      {getData?.dispatch?.address}
                      <br />
                      State : {getData?.dispatch?.state} &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp; 
                      Code : {getData?.dispatch?.code}
                       <br />
                      {getData?.dispatch?.phone} &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                      {getData?.dispatch?.email}
                    </address>
                  </td>
                </tr>
              </tbody>
            </table>
     
            <table className="table table-bordered fs-13 text-dark" width="100%">
              <thead>
                <tr>
                  <th rowSpan="2" width="2%">
                    S.No
                  </th>
                  <th rowSpan="2">PARTICULARS</th>
                  <th rowSpan="2" width="8%" className="text-center">
                    HSN/SAC
                  </th>
                  <th rowSpan="2" width="7%" className="text-center">
                    CRATES
                  </th>
                  <th rowSpan="2" width="7%" className="text-center">
                    QTY
                  </th>
                  <th rowSpan="2" width="7%" className="text-center">
                    LTR/KG
                  </th>
                  <th rowSpan="2" width="7%" className="text-center">
                    RATE/QTY
                  </th>
                

                  {getData?.dealerData?.gstType === "SGST" ? (
                    <>
                      <th colSpan="2" width="8%" className="text-center">
                        CGST
                      </th>
                      <th colSpan="2" width="8%" className="text-center">
                        SGST
                      </th>
                    </>
                  ) : (
                    <th colSpan="2" width="16%" className="text-center">
                      IGST
                    </th>
                  )}

                  <th rowSpan="2" width="10%" className="text-center">
                    Amount
                  </th>
                </tr>

                <tr>
                  {getData?.dealerData?.gstType === "SGST" ? (
                    <>
                      <th>Rate(%)</th>
                      <th>Value</th>
                      <th>Rate(%)</th>
                      <th>Value</th>
                    </>
                  ) : (
                    <>
                      <th>Rate(%)</th>
                      <th>Value</th>
                    </>
                  )}
                </tr>
              </thead>

              <tbody>
                {getData?.orderData?.map((data, index) => {
                  const price = parseFloat(data.itemPrice);
                  const gst = parseFloat(data.itemGst);
                  const productGst = parseFloat(
                    price - price / (1 + gst / 100)
                  );
                  const productPrice = parseFloat(price - productGst);
                  const disCrates = getDiscountCrates(data.itemId);
                  const rate = parseFloat(
                    productPrice.toFixed(2) *
                      ((parseFloat(data.qty) + parseFloat(disCrates)) *
                        parseFloat(data.itemGrade))
                  ).toFixed(2);
                  const gstRate = rate * (parseFloat(data.itemGst) / 100);
                  const gstRate2 = parseFloat(gstRate / 2).toFixed(2);

                  return (
                    <tr key={index} >
                      <td class="text-center">{index + 1}</td>
                      <td class="text-left">{data.itemName}</td>
                      <td class="text-left">{data.itemHsn}</td>
                     
                      <td class="text-end">
                        {(parseFloat(data.qty) + parseFloat(disCrates)).toFixed(2)}
                      </td>
                      <td class="text-end">
                        {(
                          (parseFloat(data.qty) + parseFloat(disCrates)) *
                          parseFloat(data.itemGrade)
                        ).toFixed(2)}
                      </td>
                      <td class="text-end">
                        {(
                          ((parseFloat(data.qty) + parseFloat(disCrates)) *
                            parseFloat(data.itemGrade) *
                            parseFloat(data.itemWeight)) /
                          1000
                        ).toFixed(2)}
                      </td>
                      <td class="text-end">{parseFloat(productPrice).toFixed(2)}</td>
                     
                      {getData?.dealerData?.gstType === "SGST" ? (
                        <>
                          <td class="text-center">{parseFloat(data.itemGst / 2).toFixed(1)}%</td>
                          <td class="text-end">{parseFloat(gstRate / 2).toFixed(2)}</td>
                          <td class="text-center">{parseFloat(data.itemGst / 2).toFixed(1)}%</td>
                          <td class="text-end">{parseFloat(gstRate / 2).toFixed(2)}</td>
                        </>
                      ) : (
                        <>
                          <td class="text-center">{parseFloat(data.itemGst).toFixed(1)}%</td>
                          <td class="text-end">{parseFloat(gstRate).toFixed(2)}</td>
                        </>
                      )}
                      <td class="text-end">
                        {(
                          parseFloat(rate) +
                          parseFloat(gstRate2) +
                          parseFloat(gstRate2)
                        ).toFixed(2)}
                      </td>
                    </tr>
                  );
                })}

                <tr className="fs-14">
                  <th colspan="3">TOTAL</th>
                  <th className="text-end">{parseFloat(crates).toFixed(2)}</th>
                  <th className="text-end">{parseFloat(qty).toFixed(2)}</th>
                  <th className="text-end">{parseFloat(weight).toFixed(2)}</th>
                  <th></th>
                  {getData?.dealerData?.gstType === "SGST" ? (
                    <>
                      <th></th>
                      <th className="text-end">{parseFloat(gst).toFixed(2)}</th>
                      <td></td>
                      <th className="text-end">{parseFloat(gst).toFixed(2)}</th>
                    </>
                  ) : (
                    <>
                      <td></td>
                      <th className="text-end">{parseFloat(gst * 2).toFixed(2)}</th>
                    </>
                  )}
                  <th class="text-end">
                    {parseFloat(
                      parseFloat(total) + parseFloat(gst) + parseFloat(gst)
                    ).toFixed(2)}
                  </th>
                </tr>
              </tbody>
            </table>
            {i > 1 &&
              <table>
              {Array.from({ length: i }).map((_, j) => (
                    <tr key={j} className="force-no-border">
                      <td colSpan={1} className="p-3 force-no-border"></td>
                    </tr>
              ))}
              </table>
            }

            <table class="table table-bordered fs-13 text-dark" width="100%">
               <tbody>
                <tr>
                  <td width="65%" className="text-center" colSpan={4}>
                    Our Bank Details
                  </td>
                  <td width="35%" className="text-center" colSpan={2} rowSpan={2} style={{ verticalAlign: "top" }}>
                    Notes 
                    {/* <p style={{marginTop: '10px', fontSize: '12px'}}>The incentive accumulated for this month is ₹{Number(incentive).toFixed(2)}</p> */}
                    {/* <p style={{marginTop: '10px', fontSize: '12px'}}>{getData?.notes}</p> */}
                  </td>
                </tr>

                <tr>
                  <td colSpan={2}>
                    A/C Holder <br />
                    BANK<br />
                    BRANCH<br />
                    A/C NO<br />
                    IFSC CODE
                  </td>
                  <td colSpan={2}>
                    TRUCOO DAIRY PRODUCTS PRIVATE LIMITED<br />
                    UNION BANK OF INDIA<br />
                    COIMBATORE<br />
                    008311010000082<br />
                    UBIN0800830
                  </td>
                </tr>

                <tr>
                  <th
                    className="text-start"
                    colSpan={4}
                  >
                    Payable Amount In words <br />
                    {totalAmountInWords.toUpperCase()} RUPEES ONLY
                  </th>
               
                  <td className="text-left" >
                    <div className="flex justify-between">
                      <p style={{fontWeight: 'normal'}}>BILL AMOUNT</p>
                      <p style={{fontWeight: 'normal'}}>
                        {parseFloat(
                          parseFloat(total) + parseFloat(gst) + parseFloat(gst)
                        ).toFixed(2)}
                      </p>
                    </div>
                    <div className="flex justify-between">
                      <p style={{fontWeight: 'normal'}}>DISCOUNT</p>
                      <p style={{fontWeight: 'normal'}}>{parseFloat(discount + scheme).toFixed(2)}</p>
                    </div>
                    <div className="flex justify-between">
                      <p style={{fontWeight: 'normal'}}>ROUND AMOUNT</p>
                      <p style={{fontWeight: 'normal'}}>
                        {parseFloat(
                          parseFloat(Math.round(payable)) -
                          parseFloat(total) - 
                          parseFloat(gst) - 
                          parseFloat(gst) +
                          parseFloat(discount) -
                          parseFloat(scheme)
                        ).toFixed(2)}</p>
                    </div>
                    <hr style={{margin: '5px 2px'}} />
                    <div className="flex justify-between">
                      <p style={{fontSize: '16px'}}>GRAND TOTAL</p>
                      <p style={{fontSize: '16px'}}> {parseFloat(Math.round(payable)).toFixed(2)}</p>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td
                    className="text-left"
                    colSpan={4}
                    style={{verticalAlign: 'top', paddingBottom: "30px" }}
                  >
                    <b>Declaration</b> <br />
                    We declare that this invoice shows the actual price of the
                    goods described and that all particulars are true and
                    correct.
                  </td>
                  <td
                    className="text-left"
                    colSpan={2}
                    style={{verticalAlign: 'top', paddingBottom: "30px" }}
                  >
                    Authorized Signature
                  </td>
                </tr>

                <tr>
                  <td className="text-center" colSpan={6}>
                    This is a Computer Generated Invoice
                  </td>
                </tr>
                </tbody>
            </table> 
          </div>
        </div>
      </section>
      {/* --------------Sheet 2 ------------ */}

      <section
        className="invoice hide"
        id="printableArea2"
        style={{
          maxWidth: "100%",
          minWidth: "265mm",
          padding: "5mm",
          boxSizing: "border-box",
          border: "1px solid #000",
          justifyContent: "center",
        }}
      >
        <div className="row align-items-center justify-content-md-center h-p100">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th
                    colspan="3"
                    className="text-center border-bottom text-bold"
                    style={{ padding: "20px 5px", fontSize: "20px" }}
                  >
                    E-Way Bill
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td
                    colspan="2"
                    className="text-dark border-bottom"
                    style={{ paddingTop: "20px" }}
                  >
                    Doc No. : <b>Tax Invoice - {getData?.ewb?.docNo}</b> <br />
                    Date : <b>{formatViewDate(getData?.ewb?.docDate)}</b>
                  </td>
                  <td
                    className="text-dark border-bottom text-end"
                    style={{ paddingTop: "20px" }}
                  >
                    {payable && payable > 0 && (
                      <QRCodeCanvas value={ewayQr} size={150} />
                    )}
                  </td>
                </tr>
              </tbody>
            </table>

            <table class="table">
              <tr>
                <th colspan="3" style={{ padding: "20px 0px" }}>
                  1. E-Way Bill Details
                </th>
              </tr>
              <tr>
                <td style={{ padding: "3px 20px" }}>
                  <span>
                    E-Way Bill No. : <b>{getData?.eWayNum}</b>
                  </span>
                </td>
                <td style={{ padding: "3px 20px" }}>
                  <span>
                    Mode :{" "}
                    <b>
                      {getData?.ewb?.tMode === "1"
                        ? "1-Road"
                        : getData?.ewb?.tMode === "2"
                        ? "2-Rail"
                        : getData?.ewb?.tMode === "3"
                        ? "3-Air"
                        : getData?.ewb?.tMode === "4"
                        ? "4-Ship"
                        : `${getData?.ewb?.tMode}-Unknown`}
                    </b>
                  </span>
                </td>
                <td style={{ padding: "3px 20px" }}>
                  <span>
                    Generated Date : <b>{getData?.ewb?.created}</b>
                  </span>
                </td>
              </tr>
              <tr>
                <td style={{ padding: "3px 20px" }}>
                  <span>
                    Generated By : <b>{companyData?.companyGst}</b>
                  </span>
                </td>
                <td style={{ padding: "3px 20px" }}>
                  <span>
                    Approx Distance : <b>{getData?.ewb?.dist} KM</b>
                  </span>
                </td>
                <td style={{ padding: "3px 20px" }}>
                  <span>
                    Valid Upto : <b>{getData?.ewb?.valid}</b>
                  </span>
                </td>
              </tr>
              <tr>
                <td
                  className="text-dark border-bottom"
                  style={{ padding: "3px 20px" }}
                >
                  Supply Type :{" "}
                  <b>
                    {getData?.ewb?.sType === "O"
                      ? "Outward-Supply"
                      : "Inward-Supply"}
                  </b>
                </td>
                <td
                  className="text-dark border-bottom"
                  style={{ padding: "3px 20px" }}
                  colspan="2"
                >
                  Transaction Type :{" "}
                  <b>
                    {getData?.ewb?.docType === "INV"
                      ? "Tax Invoice"
                      : getData?.ewb?.docType === "CHL"
                      ? "Delivery CHellan"
                      : getData?.ewb?.docType === "BIL"
                      ? "Bill of Supply"
                      : getData?.ewb?.docType === "BOE"
                      ? "Bill of Entry"
                      : "Others"}
                  </b>
                </td>
              </tr>
            </table>

            <table className="table">
              <tr>
                <th colspan="2" style={{ paddingTop: "20px" }}>
                  2. Address Details
                </th>
              </tr>
              <tr>
                <td width="50%" style={{ padding: "10px 20px" }}>
                  <span class="text-bold">From</span>
                  <br />
                  <span>
                    {companyData?.companyName} <br />
                    {companyData?.companyAddress1},{" "}
                    {companyData?.companyAddress2}
                    {companyData?.companyLocation}, {companyData?.companyCity},
                    {companyData?.companyState} - {companyData?.companyZip}
                  </span>
                </td>
                <td width="50%" style={{ padding: "10px 20px" }}>
                  <span class="text-bold">To</span>
                  <br />
                  <span>
                    {getData?.dealerData?.dealer}
                    <br />
                    {getData?.dealerData?.address}
                  </span>
                </td>
              </tr>
              <tr>
                <td
                  width="50%"
                  className="text-dark border-bottom"
                  style={{ padding: "10px 20px" }}
                >
                  <span class="text-bold">Dispatch From</span>
                  <br />
                  <span>
                    {getData?.dispatch?.company}
                    <br />
                    {getData?.dispatch?.address}
                  </span>
                </td>
                <td
                  width="50%"
                  className="text-dark border-bottom"
                  style={{ padding: "10px 20px" }}
                >
                  <span class="text-bold">Ships To</span>
                  <br />
                  <span>
                    {getData?.shipping?.company}
                    <br />
                    {getData?.shipping?.address}
                  </span>
                </td>
              </tr>
            </table>

            <table className="table">
              <tr>
                <th colspan="5" style={{ padding: "20px 0px" }}>
                  3. Goods Details
                </th>
              </tr>
              <tr className="table-bordered">
                <th style={{ padding: "10px 20px" }} width="10%">
                  HSN Code
                </th>
                <th style={{ padding: "10px 20px" }}>Product Name</th>
                <th
                  style={{ padding: "10px 20px" }}
                  width="10%"
                  class="text-end"
                >
                  Quantity
                </th>
                <th
                  style={{ padding: "10px 20px" }}
                  width="15%"
                  class="text-end"
                >
                  Taxable Amount
                </th>
                <th
                  style={{ padding: "10px 20px" }}
                  width="15%"
                  class="text-end"
                >
                  Tax Rate
                </th>
              </tr>
              {getData?.orderData?.map((data, index) => {
                const price = parseFloat(data.itemPrice);
                const gst = parseFloat(data.itemGst);
                const productGst = parseFloat(price - price / (1 + gst / 100));
                const productPrice = parseFloat(price - productGst);
                const disCrates = getDiscountCrates(data.itemId);

                return (
                  <tr className="table-bordered">
                    <td style={{ padding: "5px 20px" }}>{data.itemHsn}</td>
                    <td style={{ padding: "5px 20px" }}>{data.itemName}</td>
                    <td style={{ padding: "5px 20px" }} class="text-end">
                      {data.qty}
                    </td>
                    <td style={{ padding: "5px 20px" }} class="text-end">
                      {parseFloat(
                        productPrice *
                          (parseFloat(data.qty) + parseFloat(disCrates)) *
                          parseFloat(data.itemGrade)
                      ).toFixed(2)}
                    </td>
                    <td style={{ padding: "5px 20px" }} class="text-end">
                      {data.itemGst}
                    </td>
                  </tr>
                );
              })}
            </table>
            <hr class="mt-4" />
            <table className="table">
              <tr>
                <td style={{ padding: "3px 20px" }}>
                  <span>
                    Tot.Taxable Amt : <b>{parseFloat(total).toFixed(2)}</b>
                  </span>
                </td>
                {getData?.dealerData?.gstType === "SGST" ? (
                  <>
                    <td style={{ padding: "3px 20px" }}>
                      <span>
                        SGST Amt : <b>{parseFloat(gst).toFixed(2)}</b>
                      </span>
                    </td>
                    <td style={{ padding: "3px 20px" }}>
                      <span>
                        CGST Amt : <b>{parseFloat(gst).toFixed(2)}</b>
                      </span>
                    </td>
                  </>
                ) : (
                  <td style={{ padding: "3px 20px" }}>
                    <span>
                      IGST Amt : <b>{parseFloat(gst * 2).toFixed(2)}</b>
                    </span>
                  </td>
                )}
                <td style={{ padding: "3px 20px" }}>
                  <span>
                    Other Amount : <b>(-){parseFloat(discount).toFixed(2)}</b>
                  </span>
                </td>
                <td style={{ padding: "3px 20px" }}>
                  <span>
                    Total Inv Amt :{" "}
                    <b>
                      {parseFloat(
                        total + gst * 2 - parseFloat(discount)
                      ).toFixed(2)}
                    </b>
                  </span>
                </td>
              </tr>
            </table>
            <hr class="mt-4" />
            <table class="table">
              <tr>
                <th colspan="2" style={{ padding: "20px 0px" }}>
                  4. Transportation Details
                </th>
              </tr>
              <tr>
                <td style={{ padding: "3px 20px" }}>
                  <span>
                    Transporter ID : <b></b>
                  </span>
                </td>
                <td style={{ padding: "3px 20px" }}>
                  <span>
                    Doc No. : <b></b>
                  </span>
                </td>
              </tr>
              <tr>
                <td
                  className="text-dark border-bottom"
                  style={{ padding: "3px 20px" }}
                >
                  <span>
                    Name : <b></b>
                  </span>
                </td>
                <td
                  className="text-dark border-bottom"
                  style={{ padding: "3px 20px" }}
                >
                  <span>
                    Date : <b></b>
                  </span>
                </td>
              </tr>
            </table>

            <table class="table">
              <tr>
                <th colspan="3" style={{ padding: "20px 0px" }}>
                  5. Vehicle Details
                </th>
              </tr>
              <tr>
                <td style={{ padding: "3px 20px" }}>
                  <span>
                    Vehicle No. : <b>{getData?.vNum}</b>
                  </span>
                </td>
                <td style={{ padding: "3px 20px" }}>
                  <span>
                    From : <b>{getData?.dispatch?.location}</b>
                  </span>
                </td>
                <td style={{ padding: "3px 20px" }}>
                  <span>
                    CEWB No. : <b></b>
                  </span>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </section>

      {/* --------------Sheet 3 ------------ */}

      <section
        className="invoice hide"
        id="printableArea3"
        style={{
          maxWidth: "265mm",
          minWidth: "265mm",
          padding: "20px",
          boxSizing: "border-box",
          border: "1px solid #fff",
          justifyContent: "center",
        }}
      >
        <div style={{ marginTop: "-10px", marginBottom: "10px" }}>
          <small style={{fontSize: '9px'}}>( DUPLICATE FOR TRANSPORTER )</small>
        </div>
        <div className="row align-items-top justify-content-center">
          <div className="col-sm-3">
            <img src={Logo} width="100%" />
          </div>

          <div className="col-sm-6 text-center fs-13">
            <h4 style={{ fontWeight: "600" }}>
              {companyData?.companyName}
            </h4>
            <address>
              {companyData?.companyAddress1}, {companyData?.companyAddress2}
              <br />
              {companyData?.companyLocation}, {companyData?.companyCity},
              {companyData?.companyState} - {companyData?.companyZip} <br />
              GSTIN : {companyData?.companyGst} &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
              State : {companyData?.companyState} &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
              Code : {companyData?.code} <br />
              Phone : {companyData?.companyPhone} &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp; 
              Email : {companyData?.companyEmail}
            </address>
          </div>

          <div className="col-sm-3 d-flex justify-content-end gap-2">
            {payable && payable > 0 && (
              <div style={{display: 'flex', flexDirection: 'column', textAlign: 'center'}}>
                <QRCodeCanvas value={generateUpiLink()} size={110} />
                <small>Payment</small>
              </div>
            )}
            {getData?.eInvData?.length > 10 && (
              <div style={{display: 'flex', flexDirection: 'column', textAlign: 'center'}}>
                <QRCodeCanvas value={getData?.eInvData} size={110} />
                <small>E-Invoice</small>
              </div>
            )}
          </div>

          <div className="table-responsive">
            <table className="table table-bordered text-dark fs-12" width="100%">
              <thead>
                <tr>
                  <th className="text-center" colSpan="3">
                    Tax Invoice
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td width="70%">
                    <address>
                      <p className="text-uppercase">
                        Billing Address
                      </p>
                      <h6 style={{ fontWeight: "600", fontSize: "14px" }}>
                        {getData?.dealerData?.dealer}
                      </h6>
                      {getData?.dealerData?.address} - {}{getData?.dealerData?.pincode}
                      <br />
                      GSTIN : {getData?.dealerData?.gst} &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                      State : {getData?.dealerData?.state} &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                      Code : {getData?.dealerData?.stateCode}
                      <br />
                      {getData?.dealerData?.phone} &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                      {getData?.dealerData?.email}
                    </address>
                  </td>
                  <td width="30%" className="fs-13" >
                    <p className="text-uppercase">Invoice Details</p>
                    <div className="flex justify-between">
                      <p>Date</p>
                      <p>{formatViewDate(getData?.date)}</p> 
                    </div>
                    <div className="flex justify-between">
                      <p>Invoice No</p>
                      <p>TRC/{getData?.invoiceId}/{getFiscalYearLabel(new Date(getData?.date))}</p>
                    </div>
                    <div className="flex justify-between">
                      <p>Route</p>
                      <p>{getData?.dealerData?.routes}</p>
                    </div>
                    {/* <div className="flex justify-between">
                      <p>Place</p>
                      <p>{getData?.dealerData?.locations}</p>
                    </div> */}
                    <div className="flex justify-between">
                      <p>Vehicle No</p>
                      <p>{getData?.vNum}</p>
                    </div>
                    <div className="flex justify-between">
                      <p>E-Way Bill</p>
                      <p>{getData?.eWayNum}</p>
                    </div>
                  </td>
                </tr>
              </tbody>
              </table>

              {getData?.eInvNo?.length > 5 &&
                <table className="table table-bordered text-dark fs-12" width="100%">
                  <thead>
                    <tr>
                      <th>IRN : {getData?.eInvNo}</th>
                      <th>Ack No : {getData?.eInvAkn}</th>
                      <th>Ack Date : {formatDateEinv(getData?.date)}</th>
                    </tr>  
                  </thead>    
                </table>
              }

              <table className="table table-bordered text-dark fs-12" width="100%">
              <tbody>
                <tr>
                  <td
                    width="50%"
                    className="text-dark"
                    style={{ verticalAlign: "top" }}
                  >
                    <address>
                      <p className="text-dark text-uppercase">
                        Shipping Address
                      </p>
                      <h6 style={{ fontWeight: "600", fontSize: "14px" }}>
                        {getData?.shipping?.company}
                      </h6>
                      {getData?.shipping?.address}
                      <br />
                      State : {getData?.dealerData?.state}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp; 
                      Code : {getData?.dealerData?.stateCode}
                      <br />
                      {getData?.shipping?.phone} &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                      {getData?.shipping?.email}
                    </address>
                  </td>
                  <td className="text-dark" style={{ verticalAlign: "top" }}>
                    <address>
                      <p className="text-dark text-uppercase">Dispatch From</p>
                      <h6 style={{ fontWeight: "600", fontSize: "14px" }}>
                        {getData?.dispatch?.company}
                      </h6>
                      {getData?.dispatch?.address}
                      <br />
                      State : {getData?.dispatch?.state} &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp; 
                      Code : {getData?.dispatch?.code}
                       <br />
                      {getData?.dispatch?.phone} &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                      {getData?.dispatch?.email}
                    </address>
                  </td>
                </tr>
              </tbody>
            </table>
     
            <table className="table table-bordered fs-13 text-dark" width="100%">
              <thead>
                <tr>
                  <th rowSpan="2" width="2%">
                    S.No
                  </th>
                  <th rowSpan="2">PARTICULARS</th>
                  <th rowSpan="2" width="8%" className="text-center">
                    HSN/SAC
                  </th>
                  <th rowSpan="2" width="7%" className="text-center">
                    CRATES
                  </th>
                  <th rowSpan="2" width="7%" className="text-center">
                    QTY
                  </th>
                  <th rowSpan="2" width="7%" className="text-center">
                    LTR/KG
                  </th>
                  <th rowSpan="2" width="7%" className="text-center">
                    RATE/QTY
                  </th>
                

                  {getData?.dealerData?.gstType === "SGST" ? (
                    <>
                      <th colSpan="2" width="8%" className="text-center">
                        CGST
                      </th>
                      <th colSpan="2" width="8%" className="text-center">
                        SGST
                      </th>
                    </>
                  ) : (
                    <th colSpan="2" width="16%" className="text-center">
                      IGST
                    </th>
                  )}

                  <th rowSpan="2" width="10%" className="text-center">
                    Amount
                  </th>
                </tr>

                <tr>
                  {getData?.dealerData?.gstType === "SGST" ? (
                    <>
                      <th>Rate(%)</th>
                      <th>Value</th>
                      <th>Rate(%)</th>
                      <th>Value</th>
                    </>
                  ) : (
                    <>
                      <th>Rate(%)</th>
                      <th>Value</th>
                    </>
                  )}
                </tr>
              </thead>

              <tbody>
                {getData?.orderData?.map((data, index) => {
                  const price = parseFloat(data.itemPrice);
                  const gst = parseFloat(data.itemGst);
                  const productGst = parseFloat(
                    price - price / (1 + gst / 100)
                  );
                  const productPrice = parseFloat(price - productGst);
                  const disCrates = getDiscountCrates(data.itemId);
                  const rate = parseFloat(
                    productPrice.toFixed(2) *
                      ((parseFloat(data.qty) + parseFloat(disCrates)) *
                        parseFloat(data.itemGrade))
                  ).toFixed(2);
                  const gstRate = rate * (parseFloat(data.itemGst) / 100);
                  const gstRate2 = parseFloat(gstRate / 2).toFixed(2);

                  return (
                    <tr key={index} >
                      <td class="text-center">{index + 1}</td>
                      <td class="text-left">{data.itemName}</td>
                      <td class="text-left">{data.itemHsn}</td>
                     
                      <td class="text-end">
                        {(parseFloat(data.qty) + parseFloat(disCrates)).toFixed(2)}
                      </td>
                      <td class="text-end">
                        {(
                          (parseFloat(data.qty) + parseFloat(disCrates)) *
                          parseFloat(data.itemGrade)
                        ).toFixed(2)}
                      </td>
                      <td class="text-end">
                        {(
                          ((parseFloat(data.qty) + parseFloat(disCrates)) *
                            parseFloat(data.itemGrade) *
                            parseFloat(data.itemWeight)) /
                          1000
                        ).toFixed(2)}
                      </td>
                      <td class="text-end">{parseFloat(productPrice).toFixed(2)}</td>
                     
                      {getData?.dealerData?.gstType === "SGST" ? (
                        <>
                          <td class="text-center">{parseFloat(data.itemGst / 2).toFixed(1)}%</td>
                          <td class="text-end">{parseFloat(gstRate / 2).toFixed(2)}</td>
                          <td class="text-center">{parseFloat(data.itemGst / 2).toFixed(1)}%</td>
                          <td class="text-end">{parseFloat(gstRate / 2).toFixed(2)}</td>
                        </>
                      ) : (
                        <>
                          <td class="text-center">{parseFloat(data.itemGst).toFixed(1)}%</td>
                          <td class="text-end">{parseFloat(gstRate).toFixed(2)}</td>
                        </>
                      )}
                      <td class="text-end">
                        {(
                          parseFloat(rate) +
                          parseFloat(gstRate2) +
                          parseFloat(gstRate2)
                        ).toFixed(2)}
                      </td>
                    </tr>
                  );
                })}

                <tr className="fs-14">
                  <th colspan="3">TOTAL</th>
                  <th className="text-end">{parseFloat(crates).toFixed(2)}</th>
                  <th className="text-end">{parseFloat(qty).toFixed(2)}</th>
                  <th className="text-end">{parseFloat(weight).toFixed(2)}</th>
                  <th></th>
                  {getData?.dealerData?.gstType === "SGST" ? (
                    <>
                      <th></th>
                      <th className="text-end">{parseFloat(gst).toFixed(2)}</th>
                      <td></td>
                      <th className="text-end">{parseFloat(gst).toFixed(2)}</th>
                    </>
                  ) : (
                    <>
                      <td></td>
                      <th className="text-end">{parseFloat(gst * 2).toFixed(2)}</th>
                    </>
                  )}
                  <th class="text-end">
                    {parseFloat(
                      parseFloat(total) + parseFloat(gst) + parseFloat(gst)
                    ).toFixed(2)}
                  </th>
                </tr>
              </tbody>
            </table>
            {i > 1 &&
              <table>
              {Array.from({ length: i }).map((_, j) => (
                    <tr key={j} className="force-no-border">
                      <td colSpan={1} className="p-3 force-no-border"></td>
                    </tr>
              ))}
              </table>
            }

            <table class="table table-bordered fs-13 text-dark" width="100%">
               <tbody>
                <tr>
                  <td width="65%" className="text-center" colSpan={4}>
                    Our Bank Details
                  </td>
                  <td width="35%" className="text-center" colSpan={2} rowSpan={2} style={{ verticalAlign: "top" }}>
                    Notes 
                    {/* <p style={{marginTop: '10px', fontSize: '12px'}}>The incentive accumulated for this month is ₹{Number(incentive).toFixed(2)}</p> */}
                    {/* <p style={{marginTop: '10px', fontSize: '12px'}}>{getData?.notes}</p> */}
                  </td>
                </tr>

                <tr>
                  <td colSpan={2}>
                    A/C Holder <br />
                    BANK<br />
                    BRANCH<br />
                    A/C NO<br />
                    IFSC CODE
                  </td>
                  <td colSpan={2}>
                    TRUCOO DAIRY PRODUCTS PRIVATE LIMITED<br />
                    UNION BANK OF INDIA<br />
                    COIMBATORE<br />
                    008311010000082<br />
                    UBIN0800830
                  </td>
                </tr>

                <tr>
                  <th
                    className="text-start"
                    colSpan={4}
                  >
                    Payable Amount In words <br />
                    {totalAmountInWords.toUpperCase()} RUPEES ONLY
                  </th>
               
                  <td className="text-left" >
                    <div className="flex justify-between">
                      <p style={{fontWeight: 'normal'}}>BILL AMOUNT</p>
                      <p style={{fontWeight: 'normal'}}>
                        {parseFloat(
                          parseFloat(total) + parseFloat(gst) + parseFloat(gst)
                        ).toFixed(2)}
                      </p>
                    </div>
                    <div className="flex justify-between">
                      <p style={{fontWeight: 'normal'}}>DISCOUNT</p>
                      <p style={{fontWeight: 'normal'}}>{parseFloat(discount + scheme).toFixed(2)}</p>
                    </div>
                    <div className="flex justify-between">
                      <p style={{fontWeight: 'normal'}}>ROUND AMOUNT</p>
                      <p style={{fontWeight: 'normal'}}>
                        {parseFloat(
                          parseFloat(Math.round(payable)) -
                          parseFloat(total) - 
                          parseFloat(gst) - 
                          parseFloat(gst) +
                          parseFloat(discount) -
                          parseFloat(scheme)
                        ).toFixed(2)}</p>
                    </div>
                    <hr style={{margin: '5px 2px'}} />
                    <div className="flex justify-between">
                      <p style={{fontSize: '16px'}}>GRAND TOTAL</p>
                      <p style={{fontSize: '16px'}}> {parseFloat(Math.round(payable)).toFixed(2)}</p>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td
                    className="text-left"
                    colSpan={4}
                    style={{verticalAlign: 'top', paddingBottom: "30px" }}
                  >
                    <b>Declaration</b> <br />
                    We declare that this invoice shows the actual price of the
                    goods described and that all particulars are true and
                    correct.
                  </td>
                  <td
                    className="text-left"
                    colSpan={2}
                    style={{verticalAlign: 'top', paddingBottom: "30px" }}
                  >
                    Authorized Signature
                  </td>
                </tr>

                <tr>
                  <td className="text-center" colSpan={6}>
                    This is a Computer Generated Invoice
                  </td>
                </tr>
                </tbody>
            </table> 
          </div>
        </div>
      </section>

      {/* --------------Sheet 4 ------------ */}

      <section
        className="invoice hide"
        id="printableArea4"
        style={{
          maxWidth: "265mm",
          minWidth: "265mm",
          padding: "20px",
          boxSizing: "border-box",
          border: "1px solid #fff",
          justifyContent: "center",
        }}
      >
        <div style={{ marginTop: "-10px", marginBottom: "10px" }}>
          <small style={{fontSize: '9px'}}>( TRIPLICATE FOR OFFICE )</small>
        </div>
        <div className="row align-items-top justify-content-center">
          <div className="col-sm-3">
            <img src={Logo} width="100%" />
          </div>

          <div className="col-sm-6 text-center fs-13">
            <h4 style={{ fontWeight: "600" }}>
              {companyData?.companyName}
            </h4>
            <address>
              {companyData?.companyAddress1}, {companyData?.companyAddress2}
              <br />
              {companyData?.companyLocation}, {companyData?.companyCity},
              {companyData?.companyState} - {companyData?.companyZip} <br />
              GSTIN : {companyData?.companyGst} &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
              State : {companyData?.companyState} &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
              Code : {companyData?.code} <br />
              Phone : {companyData?.companyPhone} &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp; 
              Email : {companyData?.companyEmail}
            </address>
          </div>

          <div className="col-sm-3 d-flex justify-content-end gap-2">
            {payable && payable > 0 && (
              <div style={{display: 'flex', flexDirection: 'column', textAlign: 'center'}}>
                <QRCodeCanvas value={generateUpiLink()} size={110} />
                <small>Payment</small>
              </div>
            )}
            {getData?.eInvData?.length > 10 && (
              <div style={{display: 'flex', flexDirection: 'column', textAlign: 'center'}}>
                <QRCodeCanvas value={getData?.eInvData} size={110} />
                <small>E-Invoice</small>
              </div>
            )}
          </div>

          <div className="table-responsive">
            <table className="table table-bordered text-dark fs-12" width="100%">
              <thead>
                <tr>
                  <th className="text-center" colSpan="3">
                    Tax Invoice
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td width="70%">
                    <address>
                      <p className="text-uppercase">
                        Billing Address
                      </p>
                      <h6 style={{ fontWeight: "600", fontSize: "14px" }}>
                        {getData?.dealerData?.dealer}
                      </h6>
                      {getData?.dealerData?.address} - {}{getData?.dealerData?.pincode}
                      <br />
                      GSTIN : {getData?.dealerData?.gst} &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                      State : {getData?.dealerData?.state} &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                      Code : {getData?.dealerData?.stateCode}
                      <br />
                      {getData?.dealerData?.phone} &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                      {getData?.dealerData?.email}
                    </address>
                  </td>
                  <td width="30%" className="fs-13" >
                    <p className="text-uppercase">Invoice Details</p>
                    <div className="flex justify-between">
                      <p>Date</p>
                      <p>{formatViewDate(getData?.date)}</p> 
                    </div>
                    <div className="flex justify-between">
                      <p>Invoice No</p>
                      <p>TRC/{getData?.invoiceId}/{getFiscalYearLabel(new Date(getData?.date))}</p>
                    </div>
                    <div className="flex justify-between">
                      <p>Route</p>
                      <p>{getData?.dealerData?.routes}</p>
                    </div>
                    {/* <div className="flex justify-between">
                      <p>Place</p>
                      <p>{getData?.dealerData?.locations}</p>
                    </div> */}
                    <div className="flex justify-between">
                      <p>Vehicle No</p>
                      <p>{getData?.vNum}</p>
                    </div>
                    <div className="flex justify-between">
                      <p>E-Way Bill</p>
                      <p>{getData?.eWayNum}</p>
                    </div>
                  </td>
                </tr>
              </tbody>
              </table>

              {getData?.eInvNo?.length > 5 &&
                <table className="table table-bordered text-dark fs-12" width="100%">
                  <thead>
                    <tr>
                      <th>IRN : {getData?.eInvNo}</th>
                      <th>Ack No : {getData?.eInvAkn}</th>
                      <th>Ack Date : {formatDateEinv(getData?.date)}</th>
                    </tr>  
                  </thead>    
                </table>
              }

              <table className="table table-bordered text-dark fs-12" width="100%">
              <tbody>
                <tr>
                  <td
                    width="50%"
                    className="text-dark"
                    style={{ verticalAlign: "top" }}
                  >
                    <address>
                      <p className="text-dark text-uppercase">
                        Shipping Address
                      </p>
                      <h6 style={{ fontWeight: "600", fontSize: "14px" }}>
                        {getData?.shipping?.company}
                      </h6>
                      {getData?.shipping?.address}
                      <br />
                      State : {getData?.dealerData?.state}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp; 
                      Code : {getData?.dealerData?.stateCode}
                      <br />
                      {getData?.shipping?.phone} &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                      {getData?.shipping?.email}
                    </address>
                  </td>
                  <td className="text-dark" style={{ verticalAlign: "top" }}>
                    <address>
                      <p className="text-dark text-uppercase">Dispatch From</p>
                      <h6 style={{ fontWeight: "600", fontSize: "14px" }}>
                        {getData?.dispatch?.company}
                      </h6>
                      {getData?.dispatch?.address}
                      <br />
                      State : {getData?.dispatch?.state} &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp; 
                      Code : {getData?.dispatch?.code}
                       <br />
                      {getData?.dispatch?.phone} &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                      {getData?.dispatch?.email}
                    </address>
                  </td>
                </tr>
              </tbody>
            </table>
     
            <table className="table table-bordered fs-13 text-dark" width="100%">
              <thead>
                <tr>
                  <th rowSpan="2" width="2%">
                    S.No
                  </th>
                  <th rowSpan="2">PARTICULARS</th>
                  <th rowSpan="2" width="8%" className="text-center">
                    HSN/SAC
                  </th>
                  <th rowSpan="2" width="7%" className="text-center">
                    CRATES
                  </th>
                  <th rowSpan="2" width="7%" className="text-center">
                    QTY
                  </th>
                  <th rowSpan="2" width="7%" className="text-center">
                    LTR/KG
                  </th>
                  <th rowSpan="2" width="7%" className="text-center">
                    RATE/QTY
                  </th>
                

                  {getData?.dealerData?.gstType === "SGST" ? (
                    <>
                      <th colSpan="2" width="8%" className="text-center">
                        CGST
                      </th>
                      <th colSpan="2" width="8%" className="text-center">
                        SGST
                      </th>
                    </>
                  ) : (
                    <th colSpan="2" width="16%" className="text-center">
                      IGST
                    </th>
                  )}

                  <th rowSpan="2" width="10%" className="text-center">
                    Amount
                  </th>
                </tr>

                <tr>
                  {getData?.dealerData?.gstType === "SGST" ? (
                    <>
                      <th>Rate(%)</th>
                      <th>Value</th>
                      <th>Rate(%)</th>
                      <th>Value</th>
                    </>
                  ) : (
                    <>
                      <th>Rate(%)</th>
                      <th>Value</th>
                    </>
                  )}
                </tr>
              </thead>

              <tbody>
                {getData?.orderData?.map((data, index) => {
                  const price = parseFloat(data.itemPrice);
                  const gst = parseFloat(data.itemGst);
                  const productGst = parseFloat(
                    price - price / (1 + gst / 100)
                  );
                  const productPrice = parseFloat(price - productGst);
                  const disCrates = getDiscountCrates(data.itemId);
                  const rate = parseFloat(
                    productPrice.toFixed(2) *
                      ((parseFloat(data.qty) + parseFloat(disCrates)) *
                        parseFloat(data.itemGrade))
                  ).toFixed(2);
                  const gstRate = rate * (parseFloat(data.itemGst) / 100);
                  const gstRate2 = parseFloat(gstRate / 2).toFixed(2);

                  return (
                    <tr key={index} >
                      <td class="text-center">{index + 1}</td>
                      <td class="text-left">{data.itemName}</td>
                      <td class="text-left">{data.itemHsn}</td>
                     
                      <td class="text-end">
                        {(parseFloat(data.qty) + parseFloat(disCrates)).toFixed(2)}
                      </td>
                      <td class="text-end">
                        {(
                          (parseFloat(data.qty) + parseFloat(disCrates)) *
                          parseFloat(data.itemGrade)
                        ).toFixed(2)}
                      </td>
                      <td class="text-end">
                        {(
                          ((parseFloat(data.qty) + parseFloat(disCrates)) *
                            parseFloat(data.itemGrade) *
                            parseFloat(data.itemWeight)) /
                          1000
                        ).toFixed(2)}
                      </td>
                      <td class="text-end">{parseFloat(productPrice).toFixed(2)}</td>
                     
                      {getData?.dealerData?.gstType === "SGST" ? (
                        <>
                          <td class="text-center">{parseFloat(data.itemGst / 2).toFixed(1)}%</td>
                          <td class="text-end">{parseFloat(gstRate / 2).toFixed(2)}</td>
                          <td class="text-center">{parseFloat(data.itemGst / 2).toFixed(1)}%</td>
                          <td class="text-end">{parseFloat(gstRate / 2).toFixed(2)}</td>
                        </>
                      ) : (
                        <>
                          <td class="text-center">{parseFloat(data.itemGst).toFixed(1)}%</td>
                          <td class="text-end">{parseFloat(gstRate).toFixed(2)}</td>
                        </>
                      )}
                      <td class="text-end">
                        {(
                          parseFloat(rate) +
                          parseFloat(gstRate2) +
                          parseFloat(gstRate2)
                        ).toFixed(2)}
                      </td>
                    </tr>
                  );
                })}

                <tr className="fs-14">
                  <th colspan="3">TOTAL</th>
                  <th className="text-end">{parseFloat(crates).toFixed(2)}</th>
                  <th className="text-end">{parseFloat(qty).toFixed(2)}</th>
                  <th className="text-end">{parseFloat(weight).toFixed(2)}</th>
                  <th></th>
                  {getData?.dealerData?.gstType === "SGST" ? (
                    <>
                      <th></th>
                      <th className="text-end">{parseFloat(gst).toFixed(2)}</th>
                      <td></td>
                      <th className="text-end">{parseFloat(gst).toFixed(2)}</th>
                    </>
                  ) : (
                    <>
                      <td></td>
                      <th className="text-end">{parseFloat(gst * 2).toFixed(2)}</th>
                    </>
                  )}
                  <th class="text-end">
                    {parseFloat(
                      parseFloat(total) + parseFloat(gst) + parseFloat(gst)
                    ).toFixed(2)}
                  </th>
                </tr>
              </tbody>
            </table>
            {i > 1 &&
              <table>
              {Array.from({ length: i }).map((_, j) => (
                    <tr key={j} className="force-no-border">
                      <td colSpan={1} className="p-3 force-no-border"></td>
                    </tr>
              ))}
              </table>
            }

            <table class="table table-bordered fs-13 text-dark" width="100%">
               <tbody>
                <tr>
                  <td width="65%" className="text-center" colSpan={4}>
                    Our Bank Details
                  </td>
                  <td width="35%" className="text-center" colSpan={2} rowSpan={2} style={{ verticalAlign: "top" }}>
                    Notes 
                    {/* <p style={{marginTop: '10px', fontSize: '12px'}}>The incentive accumulated for this month is ₹{Number(incentive).toFixed(2)}</p> */}
                    {/* <p style={{marginTop: '10px', fontSize: '12px'}}>{getData?.notes}</p> */}
                  </td>
                </tr>

                <tr>
                  <td colSpan={2}>
                    A/C Holder <br />
                    BANK<br />
                    BRANCH<br />
                    A/C NO<br />
                    IFSC CODE
                  </td>
                  <td colSpan={2}>
                    TRUCOO DAIRY PRODUCTS PRIVATE LIMITED<br />
                    UNION BANK OF INDIA<br />
                    COIMBATORE<br />
                    008311010000082<br />
                    UBIN0800830
                  </td>
                </tr>

                <tr>
                  <th
                    className="text-start"
                    colSpan={4}
                  >
                    Payable Amount In words <br />
                    {totalAmountInWords.toUpperCase()} RUPEES ONLY
                  </th>
               
                  <td className="text-left" >
                    <div className="flex justify-between">
                      <p style={{fontWeight: 'normal'}}>BILL AMOUNT</p>
                      <p style={{fontWeight: 'normal'}}>
                        {parseFloat(
                          parseFloat(total) + parseFloat(gst) + parseFloat(gst)
                        ).toFixed(2)}
                      </p>
                    </div>
                    <div className="flex justify-between">
                      <p style={{fontWeight: 'normal'}}>DISCOUNT</p>
                      <p style={{fontWeight: 'normal'}}>{parseFloat(discount + scheme).toFixed(2)}</p>
                    </div>
                    <div className="flex justify-between">
                      <p style={{fontWeight: 'normal'}}>ROUND AMOUNT</p>
                      <p style={{fontWeight: 'normal'}}>
                        {parseFloat(
                          parseFloat(Math.round(payable)) -
                          parseFloat(total) - 
                          parseFloat(gst) - 
                          parseFloat(gst) +
                          parseFloat(discount) -
                          parseFloat(scheme)
                        ).toFixed(2)}</p>
                    </div>
                    <hr style={{margin: '5px 2px'}} />
                    <div className="flex justify-between">
                      <p style={{fontSize: '16px'}}>GRAND TOTAL</p>
                      <p style={{fontSize: '16px'}}> {parseFloat(Math.round(payable)).toFixed(2)}</p>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td
                    className="text-left"
                    colSpan={4}
                    style={{verticalAlign: 'top', paddingBottom: "30px" }}
                  >
                    <b>Declaration</b> <br />
                    We declare that this invoice shows the actual price of the
                    goods described and that all particulars are true and
                    correct.
                  </td>
                  <td
                    className="text-left"
                    colSpan={2}
                    style={{verticalAlign: 'top', paddingBottom: "30px" }}
                  >
                    Authorized Signature
                  </td>
                </tr>

                <tr>
                  <td className="text-center" colSpan={6}>
                    This is a Computer Generated Invoice
                  </td>
                </tr>
                </tbody>
            </table> 
          </div>
        </div>
      </section>
    </>
  );
};

export default InvoicePage;
